import React from "react";
import sharedstyles from "../styles/SharedStyles.module.css";

export default function Treasure() {
  return (
    <div className={sharedstyles.treasureBg}>
      <div className={sharedstyles.treasureBox}>
        <div className={sharedstyles.treasureText}>SPELUNKER</div>
      </div>
    </div>
  );
}